import { useCallback, useState, useEffect } from 'react'
import _ from 'lodash'

import deleteHandler from './handlers/handleDelete'
import addHandler from './handlers/handleAdd'
import reorderHandler from './handlers/handleChangeOrder'
import categoriesHandler from './handlers/handleCategories'
import recalculateHandler from './handlers/handleRecalculate'

export default params => {

  const { onChange, model, field: variationField, ingredientsSelector, addToIngredientsList } = params
  const { selectedIngredient, selectIngredient } = ingredientsSelector
  const [showAddIngredient, setShowAddIngredient] = useState(null)
  const [showTranslatesModal, setShowTranslatesModal] = useState(null)
  const handleSelectIngredient = useCallback(path => selectIngredient(path), [selectIngredient])

  const handleTranslationChange = useCallback((field, translates) => {
    onChange({
      target: {
        value: translates,
        name: field,
      },
    })
  }, [onChange])

  const handlersParams = {
    ...params,
    showAddIngredient,
    setShowAddIngredient,
    selectIngredient,
    setShowTranslatesModal,
    showTranslatesModal,
    selectedIngredient,
    addToIngredientsList,
  }

  // reset selection if ingredient not exists enymore
  useEffect(() => {
    if (selectedIngredient && !_.get(model, `values[${variationField}].${selectedIngredient}`)) {
      selectIngredient(null)
    }
  }, [model, selectIngredient, selectedIngredient, variationField])


  const { handleAddIngredientModal, handleAddIngredient } = addHandler(handlersParams)

  const {
    handleCategoryRename,
    handleChangeCategoryTranslate,
    handleAddCategory,
    handleCreateCategory,
  } = categoriesHandler(handlersParams)

  const handleRecalculateQuantity = recalculateHandler(handlersParams)

  const { getConfirmDeleteText, handleDeleteIngredient } = deleteHandler(handlersParams)

  const handleChangeOrder = reorderHandler(handlersParams)

  return {
    handleTranslationChange,
    handleAddIngredientModal,
    handleAddIngredient,
    handleCategoryRename,
    handleChangeCategoryTranslate,
    showTranslatesModal,
    setShowTranslatesModal,
    showAddIngredient,
    setShowAddIngredient,
    handleSelectIngredient,
    selectedIngredient,
    handleRecalculateQuantity,
    handleDeleteIngredient,
    handleChangeOrder,
    handleAddCategory,
    handleCreateCategory,
    getConfirmDeleteText,
  }
}
